import React, { useState } from "react";
import { Button } from "@mui/material";
import { RiCheckLine, RiErrorWarningLine } from "@remixicon/react";

import { useTheme } from "@mui/material/styles";
import ShippingSummaryStatusDialog from "./ShippingSummaryStatusDialog";

interface ShippingSummaryStatusAlertProps {
  status: string;
  statusType: "error" | "success" | "warning";
  customerId: string;
  dateStart: string;
  dateEnd: string;
}

const ShippingSummaryStatusButton: React.FC<
  ShippingSummaryStatusAlertProps
> = ({ statusType, customerId, dateStart, dateEnd }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const toggleDialog = () => setOpen((prev) => !prev);

  return (
    <>
      <Button
        color={statusType}
        aria-label="status-button"
        onClick={toggleDialog}
        sx={{
          display: "flex",
          alignItems: "center",
          fontSize: "12px",
          gap: "4px",
          justifyContent: "start",
          width: "100%",
        }}
        disabled={statusType === "success"}
        disableRipple
      >
        {statusType === "success" ? (
          <RiCheckLine
            size={16}
            style={{ color: theme.palette[statusType].main }}
          />
        ) : (
          <RiErrorWarningLine
            size={16}
            style={{ color: theme.palette[statusType].main }}
          />
        )}
        <span>
          {statusType === "error" ? (
            "Errors"
          ) : statusType === "warning" ? (
            "Warnings"
          ) : (
            <span style={{ color: theme.palette.success.main }}>OK</span>
          )}
        </span>
      </Button>
      <ShippingSummaryStatusDialog
        open={open}
        onClose={toggleDialog}
        customerId={customerId}
        dateStart={dateStart}
        dateEnd={dateEnd}
      />
    </>
  );
};

export default ShippingSummaryStatusButton;
